import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type { IAppRegion } from '~/lib/appSettings';
import type {
  IApiRequestPasswordChangeRequestBody,
  IApiRequestPasswordChangeResponseBody,
} from '../AuthApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseRequestPasswordChangeMutationValues = {
  region: IAppRegion;
  body: IApiRequestPasswordChangeRequestBody;
};

export const useRequestPasswordChangeMutation = (): UseMutationResult<
  IApiRequestPasswordChangeResponseBody,
  unknown,
  IUseRequestPasswordChangeMutationValues
> => {
  const api = useApi();

  return useMutation({
    mutationFn: (values: IUseRequestPasswordChangeMutationValues) =>
      api.auth.requestPasswordChange(values.region, values.body),
  });
};
